module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "600",
      "min-width": "600",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "transition": "v-fade-transition",
      "hide-details": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog.settings.visible),
      callback: function($$v) {
        _vm.$set(_vm.dialog.settings, "visible", $$v)
      },
      expression: "dialog.settings.visible"
    }
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "padding": "5px",
      "flex-grow": "1",
      "display": "flex"
    },
    style: (_vm.bodyStyle)
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "overflow-y": "scroll",
      "height": "100%"
    }
  }, [_c('v-expansion-panel', {
    model: {
      value: (_vm.expansionPanelNumber),
      callback: function($$v) {
        _vm.expansionPanelNumber = $$v
      },
      expression: "expansionPanelNumber"
    }
  }, [_c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Properties (" + _vm._s(_vm.dialog.field.name) + ")")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "single-line": ""
    },
    model: {
      value: (_vm.dialog.field.name),
      callback: function($$v) {
        _vm.$set(_vm.dialog.field, "name", $$v)
      },
      expression: "dialog.field.name"
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.dialog.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.dialog.field.width),
      callback: function($$v) {
        _vm.$set(_vm.dialog.field, "width", $$v)
      },
      expression: "dialog.field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Layout")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', [_vm._v("Filters")])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "expansion-content"
  }, [_c('v-slider', {
    attrs: {
      "label": _vm.sliderLabel('Width', _vm.field.width),
      "step": 10,
      "color": "primary"
    },
    model: {
      value: (_vm.field.width),
      callback: function($$v) {
        _vm.$set(_vm.field, "width", $$v)
      },
      expression: "field.width"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div')]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "flex-grow": "0"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.dialog.settings.cancelLabel || 'Cancel'))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.dialog.settings.saveLabel || 'Save'))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71f1ae1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/PanelDialog.vue
// module id = 2598
// module chunks = 1